import axios from "axios";
import { globalVariables } from "../../../globalVariables";
import axiosApiCall from "../../utils/axiosAPICall";

export async function checkUserNameExcistsThroughHorizon(username) {
    return await axios.get(`${globalVariables.alt360APIUrl}/v1/User/CheckUserNameExistsThroughOrigin?userName=${username}&origin=${globalVariables.alt360AQOrigin}`)
        .then(res => {
            return res;
        }).catch(error => {
            return error;
        });
}

export async function setUser(data) {
    return await axios.post(`${globalVariables.alt360APIUrl}/v1/User/SetUser?origin=${globalVariables.alt360AQOrigin}`, data)
        .then(res => {
            return res;
        }).catch(error => {
            return error;
        });
}

export async function getUserDetailsById(userId) {
    return await axiosApiCall.get(`/v1/Lucra/GetEntraExtIDUserById?userID=${userId}`)
        .then(res => {
            return res;
        }).catch(error => {
            return error;
        });
}

export async function activateEntraExtIDUser(userId) {
    return await axiosApiCall.put(`/v1/Lucra/ActivateEntraExtIDUser?userID=${userId}`)
        .then(res => {
            return res;
        }).catch(error => {
            return error;
        });
}